import React from "react";
import CopyrightFooter from "./CopyrightFooter";
import errorAnimation from "../../assets/img/404-Error.svg";
function Error404() {
  return (
    <div className="row no-margin h-fullscreen">
      <div className="col-12">
        <div className="card card-transparent mx-auto text-center">
          <img src={errorAnimation} style={{ maxHeight: "500px" }} />
          <hr className="w-30px" />
          <h3 className="text-uppercase text-info">Page not found!</h3>
          <p className="lead text-danger">
            Seems you're looking for something that doesn't exist.
          </p>
          <ul className="nav nav-primary nav-dotted nav-dot-separated justify-content-center fs-14">
            <li className="nav-item">
              <span className="nav-link">Report problem</span>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/">
                Return home
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* <CopyrightFooter /> */}
    </div>
  );
}
export default React.memo(Error404);
